import React, {useState, useEffect, Suspense} from 'react';
import {useSelector} from 'react-redux';
import ResponsiveModal from './ResponsiveModal';
import SignatureCanvas from './SignatureCanvas';
import PickSignatureStyle from './PickSignatureStyle';
import ResponsiveSheetModal from './ResponsiveSheetModal';
import PollNom151Timestamp from './PollNom151Timestamp';
import AlertModal from './AlertModal';
import UploadDocumentModal from './UploadDocumentModal';

import { useTranslation } from 'react-i18next';
import IdentityVerificationModal from "./IdentityVerificationModal";
import ConfirmEndorsementModal from "./ConfirmEndorsementModal";

export default function TaskModal() {

    const {t} = useTranslation()
    const drawingSignature = useSelector(state => state.status.drawingSignature);
    const pickingSignatureStyle = useSelector(state => state.status.pickingSignatureStyle);
    const verifyingIdentity = useSelector(state => state.status.verifyingIdentity);
    const confirmEndorsement = useSelector(state => state.status.confirmEndorsement)
    const waitingNom151Timestamp = useSelector(state => state.status.waitingNom151Timestamp);
    const showingAlert = useSelector(state => state.status.showingAlert);
    const uploadingDocument = useSelector(state => state.status.uploadingDocument)

    function handleDrawingDone(data) {
        drawingSignature.data.resolve(data);
    }

    function handleDrawingCancel() {
        drawingSignature.data.reject();
    }

    function handlePickSignatureDone(imageData) {
        pickingSignatureStyle.data.resolve(imageData);
    }

    function handlePickSignatureCancel() {
        pickingSignatureStyle.data.resolve();
    }

    function handleIdentityVerificationDone(data) {
        verifyingIdentity.resolve(data)
    }

    function handleIdentityVerificationCancel() {
        verifyingIdentity.reject('canceled');
    }

    function handleConfirmEndorsement() {
        confirmEndorsement.resolve();
    }

    function handleCancelEndorsement() {
        confirmEndorsement.reject();
    }

    return (
        <React.Fragment>
            <ResponsiveModal isOpen={drawingSignature.working}
                onCancel={handleDrawingCancel}
                title='signatureDrawing'>
                <SignatureCanvas
                    imageType={drawingSignature.data ? drawingSignature.data.imageType : 'stroke'}
                    singleUse={drawingSignature.data ? drawingSignature.data.singleUse : false}
                    onDone={handleDrawingDone}
                    onCancel={handleDrawingCancel}></SignatureCanvas>
            </ResponsiveModal>
            <Suspense fallback={<div></div>}>
                <PickSignatureStyle
                    isOpen={pickingSignatureStyle.working}
                    stickerId={pickingSignatureStyle.data.stickerId}
                    commonName={pickingSignatureStyle.data.commonName}
                    issuerName={pickingSignatureStyle.data.issuerName}
                    cancelable={pickingSignatureStyle.data.cancelable}
                    requestedImageType={pickingSignatureStyle.data.requestedImageType}
                    onDone={handlePickSignatureDone}
                    onCancel={handlePickSignatureCancel}></PickSignatureStyle>
            </Suspense>
            <PollNom151Timestamp isPolling={waitingNom151Timestamp.working}></PollNom151Timestamp>
            <AlertModal isOpen={showingAlert.working}>
                {showingAlert.children}
            </AlertModal>
            <UploadDocumentModal
                isOpen={uploadingDocument.working}
                file={uploadingDocument.file}>
            </UploadDocumentModal>
            <Suspense fallback={<div></div>}>
                {
                    verifyingIdentity.working ?
                        <IdentityVerificationModal isOpen={true}
                                                   boxId={verifyingIdentity.boxId}
                                                   onDone={handleIdentityVerificationDone}
                                                   onCancel={handleIdentityVerificationCancel}
                        ></IdentityVerificationModal>
                    : null
                }
            </Suspense>
            <Suspense fallback={<div></div>}>
                {
                    confirmEndorsement.working ?
                        <ConfirmEndorsementModal isOpen={confirmEndorsement.working}
                                                 endorsement={confirmEndorsement.endorsement}
                                                 onDone={handleConfirmEndorsement}
                                                 onCancel={handleCancelEndorsement}>

                        </ConfirmEndorsementModal>
                        : null
                }
            </Suspense>

        </React.Fragment>
    )

}
